import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import OrganizationSettingsAddUser from '@/modules/Organizations/components/settings/OrganizationSettingsAddUser.vue'
import OrganizationSettingsUserChip from '@/modules/Organizations/components/settings/OrganizationSettingsUserChip.vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Organization, OrganizationUser, UserRole } from '@/modules/Organizations/types'
import { addUserWithRole, removeUserWithRole } from '@/enitites/organization/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsAdmins',
  props: {
    org: null
  },
  setup(__props: any) {

const props = __props as { org: Organization };



const isEditMode = ref(false)

const excludedUsersIds = computed(() => props.org.admins.map((a) => a.id))

const addAdmin = async (user: OrganizationUser, role: UserRole) => {
  const resp = await addUserWithRole(props.org.id, user.id, role)
  if (resp) props.org.admins.push(user)
}

const removeAdmin = async (user: OrganizationUser, role: UserRole) => {
  const resp = await removeUserWithRole(props.org.id, user.id, role)
  if (resp) props.org.admins = props.org.admins.filter((admin) => admin.id !== user.id)
}

return { __sfc: true,props, isEditMode, excludedUsersIds, addAdmin, removeAdmin, OrganizationSettingsAddUser, OrganizationSettingsUserChip, BKUserSelect }
}

})